import { ChannelWebhook } from "../classes/ChannelWebhook.js";
import { ClassCollection } from "./Collection.js";
/**
 * Collection of Channel Webhooks
 */
export class ChannelWebhookCollection extends ClassCollection {
    /**
     * Fetch webhook by ID
     * @param id Id
     * @returns Webhook
     */
    async fetch(id) {
        const webhook = this.get(id);
        if (webhook)
            return webhook;
        const data = await this.client.api.get(`/webhooks/${id}`);
        return this.getOrCreate(data.id, data);
    }
    /**
     * Create webhook with ID and token
     *
     * @deprecated NOT SUPPORTED BY THIS BACKEND. The cleanroom gateway routes
     * only POST on `/webhooks/{id}/{token}` (webhook fire); GET on that path
     * 404s. This method has no callers in the client today — it is kept only
     * for upstream API-shape parity. If you need a webhook by id and you have a
     * session, use the session-authed `/webhooks/{id}` route instead (see
     * ChannelWebhook.edit/delete). Wire up a gateway route before calling this.
     *
     * @param id Id
     * @param token Token
     * @returns Webhook
     */
    async fromToken(id, token) {
        const webhook = this.get(id);
        if (webhook)
            return webhook;
        const data = await this.client.api.get(`/webhooks/${id}/${token}`);
        return this.getOrCreate(data.id, data);
    }
    /**
     * Get or create
     * @param id Id
     * @param data Data
     */
    getOrCreate(id, data) {
        if (this.has(id)) {
            return this.get(id);
        }
        else {
            const instance = new ChannelWebhook(this, id);
            this.create(id, "channelWebhook", instance, this.client, data);
            return instance;
        }
    }
}
